import { ChangeEvent, ReactElement } from "react";
import AccessOption from "../accessOption/accessOption";
import useGetAuthorizeUrl from "../../../register/hooks/useGetAuthorizeUrl";
import getAuthorizeParams from "../../../register/util/getAuthorizeParams";
import {
  PATH_TO_REGISTER_PARENT,
  PATH_TO_REGISTER,
} from "../../../../constants/navigation";
import styles from "./access-option-group.module.css";

const AccessOptionGroup = ({
  onChange,
}: {
  onChange?: (s: string, e: ChangeEvent<HTMLInputElement>) => void;
}): ReactElement => {
  const { data: authorizeData } = useGetAuthorizeUrl({
    ...getAuthorizeParams(),
  });

  const registrationUrl = `${PATH_TO_REGISTER_PARENT}${PATH_TO_REGISTER}${window.location.search}`;
  const loginUrl = authorizeData?.redirectUrl ?? "";

  return (
    <div className={styles.accessOptionGroup}>
      <AccessOption
        id={"register-option"}
        label={"I'm new to Justworks"}
        description={"We'll help you create an account."}
        value={registrationUrl}
        onChange={onChange}
      />
      <AccessOption
        id={"login-option"}
        label={"I already have an account"}
        description={"Great, you can use your existing login info."}
        value={loginUrl}
        onChange={onChange}
      />
    </div>
  );
};

export default AccessOptionGroup;
